import {
    FETCH_POWER_GUIDANCE,
    SET_POWER_GUIDANCE_COURSE_NAME,
    SET_POWER_GUIDANCE_EFFORT_LEVEL,
    DELETE_POWER_GUIDANCE,
    SEND_POWER_GUIDANCE_TO_DEVICE,
    DUPLICATE_POWER_GUIDANCE_STRATEGY,
    SET_POWER_GUIDANCE_SUMMARY_FROM_ALGORITHM_DATA,
    FETCH_POWER_GUIDANCE_COURSE_DETAILS,
    FETCH_POWER_GUIDANCE_DETAILS,
    SET_SPECIFIC_DATA_TO_POWER_GUIDE,
    SET_POWER_GUIDANCE_SPLITS_FROM_ALGORITHM_DATA,
    SAVE_POWER_GUIDANCE,
    UPDATE_POWER_GUIDANCE,
    FETCH_FITNESS_STATS,
    SAVE_POWER_ZONES_FROM_USER_INFO,
    UPDATE_POWER_ZONES,
    RESET_POWER_GUIDANCE_DATA,
    RESET_POWER_GUIDANCE_DELETE_ERROR,
    RESET_POWER_GUIDANCE_DUPLICATE_ERROR,
    FETCH_LATEST_FUNCTIONAL_THRESHOLD,
    SET_EVENT_FOR_POWER_GUIDE,
    SET_POWER_GUIDE_FROM_EVENT,
    FETCH_POWER_GUIDE_BY_COURSE_ID,
    SET_NUTRITION_AND_HYDRATION_WEATHER_FORECAST_TYPE,
    SET_NUTRITION_AND_HYDRATION_CUSTOM_TEMPERATURE,
    SET_NUTRITION_AND_HYDRATION_RECOMMENDATION_DATA,
    SET_NUTRITION_AND_HYDRATION_TODAY_TEMPERATURE,
    SET_POWER_GUIDE_FROM_CREATE,
    RESET_NUTRITION_AND_HYDRATION_DATA
} from './ActionTypes';

export function fetchPowerGuidance() {
    return {
        type: FETCH_POWER_GUIDANCE
    };
}

export function fetchPowerGuidanceCourseDetails(courseId, overWritePowerGuidance) {
    return {
        type: FETCH_POWER_GUIDANCE_COURSE_DETAILS,
        courseId,
        overWritePowerGuidance
    };
}

export function setPowerGuidanceName(value) {
    return {
        type: SET_POWER_GUIDANCE_COURSE_NAME,
        value
    };
}

export function setEventForPowerGuide(value) {
    return {
        type: SET_EVENT_FOR_POWER_GUIDE,
        value
    };
}

export function setPowerGuideFromEvent(value) {
    return {
        type: SET_POWER_GUIDE_FROM_EVENT,
        value
    };
}
export function setPowerGuideFromCreate(value) {
    return {
        type: SET_POWER_GUIDE_FROM_CREATE,
        value
    };
}

export function deletePowerGuidanceItem(powerGuidanceId, shouldRedirectAfterDelete) {
    return {
        type: DELETE_POWER_GUIDANCE,
        powerGuidanceId,
        shouldRedirectAfterDelete
    };
}

export function duplicatePowerGuidance(powerGuidanceId, powerGuidanceName) {
    return {
        type: DUPLICATE_POWER_GUIDANCE_STRATEGY,
        powerGuidanceId,
        powerGuidanceName
    };
}

export function sendPowerGuidanceToDevice(value) {
    return {
        type: SEND_POWER_GUIDANCE_TO_DEVICE,
        value
    };
}

export function getPowerGuidanceDetails(powerGuidancePk) {
    return {
        type: FETCH_POWER_GUIDANCE_DETAILS,
        powerGuidancePk
    };
}
export function setSpecificPowerGuideValue(key, value) {
    return {
        type: SET_SPECIFIC_DATA_TO_POWER_GUIDE,
        key,
        value
    };
}

export function setPowerGuidanceSummaryFromAlgorithmData(summary) {
    return {
        type: SET_POWER_GUIDANCE_SUMMARY_FROM_ALGORITHM_DATA,
        summary
    };
}

export function setPowerGuidanceSplitsFromAlgorithmData(splits) {
    return {
        type: SET_POWER_GUIDANCE_SPLITS_FROM_ALGORITHM_DATA,
        splits
    };
}
export function savePowerGuidance(payload, courseNotOwned, hasShareableEvent) {
    return {
        type: SAVE_POWER_GUIDANCE,
        payload,
        courseNotOwned,
        hasShareableEvent
    };
}

export function resetPowerGuidanceData() {
    return {
        type: RESET_POWER_GUIDANCE_DATA
    };
}

export function updatePowerGuidance(payload) {
    return {
        type: UPDATE_POWER_GUIDANCE,
        payload
    };
}

export function fetchFitnessStats(aggregation, groupBy, activityType, startDate, endDate, metrics) {
    return {
        type: FETCH_FITNESS_STATS,
        payload: {
            aggregation,
            groupBy,
            activityType,
            startDate,
            endDate,
            metrics
        }
    };
}

export function fetchLatestFunctionalThresholdPower(activity) {
    return {
        type: FETCH_LATEST_FUNCTIONAL_THRESHOLD,
        activity: activity
    };
}

export function savePowerZonesFromUserInfo(payload) {
    return {
        type: SAVE_POWER_ZONES_FROM_USER_INFO,
        payload
    };
}

export function updatePowerZones(powerZones) {
    return {
        type: UPDATE_POWER_ZONES,
        payload: powerZones
    };
}

export function resetPowerGuidanceDeleteFail() {
    return {
        type: RESET_POWER_GUIDANCE_DELETE_ERROR
    };
}

export function resetPowerGuidanceDuplicateFail() {
    return {
        type: RESET_POWER_GUIDANCE_DUPLICATE_ERROR
    };
}

export function fetchPowerGuideByCourseId(courseId) {
    return {
        type: FETCH_POWER_GUIDE_BY_COURSE_ID,
        courseId: courseId
    };
}

export function setNutritionAndHydrationWeatherForecastType(value) {
    return {
        type: SET_NUTRITION_AND_HYDRATION_WEATHER_FORECAST_TYPE,
        value
    };
}

export function setNutritionAndHydrationCustomTemperature(value) {
    return {
        type: SET_NUTRITION_AND_HYDRATION_CUSTOM_TEMPERATURE,
        value
    };
}

export function setNutritionAndHydrationRecommendationData(data, forecastType) {
    return {
        type: SET_NUTRITION_AND_HYDRATION_RECOMMENDATION_DATA,
        forecastType,
        data
    };
}

export function setNutritionAndHydrationTodayTemperature(data) {
    return {
        type: SET_NUTRITION_AND_HYDRATION_TODAY_TEMPERATURE,
        todayTemperatureCelsius: data.temperatureCelsius,
        todayFeelsLikeTemperatureCelsius: data.heatIndexTemperatureCelsius
    };
}

export function resetNutritionAndHydrationData() {
    return {
        type: RESET_NUTRITION_AND_HYDRATION_DATA
    };
}
